<script lang="ts">
  import { fade } from "svelte/transition";

  import StartSlide from "./startSlide.svelte";
  import MidSlides from "./midSlides.svelte";

  export let slides;
  let slidesObj;
  let currentSlide = 0;
  let currentPage = "startSlide";
  let carousel;
  slidesObj = JSON.parse(slides);
  slidesObj.data.entry.midSlides = [
    ...slidesObj?.data?.entry?.midSlides,
    {
      backgroundImage: [
        {
          url:
            slidesObj?.data?.entry?.lastSlide[0]?.broker[0]?.brokerDetails[0]
              ?.profilePhoto[0]?.url ??
            slidesObj?.data?.entry?.lastSlide?.[0]?.backgroundImage[0]?.url,
        },
      ],
    },
  ];
</script>

<svelte:head>
  {#each slidesObj?.data?.entry?.midSlides as element}
    <link rel="preload" as="image" href={element?.backgroundImage[0]?.url} />
  {/each}
</svelte:head>

<div class="slider-container">
  <div class="slider-header px-4 px-sm-5">
    <a href="/">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 103.136 92.349"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_3"
              data-name="Rectangle 3"
              width="98.794"
              height="88.156"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-2">
            <rect
              id="Rectangle_4"
              data-name="Rectangle 4"
              width="103.136"
              height="92.349"
              fill="none"
            />
          </clipPath>
        </defs>
        <g id="Logo" transform="translate(-108.385 -196.791)">
          <g
            id="Group_2"
            data-name="Group 2"
            transform="translate(111.137 199.326)"
          >
            <g
              id="Group_1"
              data-name="Group 1"
              transform="translate(0 0)"
              clip-path="url(#clip-path)"
            >
              <path
                id="Path_1"
                data-name="Path 1"
                d="M156.114,204.659c-21.961,4.145-44.606,21.275-39.363,44.625,5.129,22.843,23.309,36.553,39.442,41.312,17.62,5.2,31.369-4.759,38.089-27.007,14.595-48.3-12.1-63.851-38.168-58.93"
                transform="translate(-115.986 -203.793)"
                fill="#0063a5"
              />
              <path
                id="Path_2"
                data-name="Path 2"
                d="M313.7,247c0-11.04-9.09-16.685-23.712-17.856,7.635,9.406,10.321,25.158,3.214,48.681q-.36,1.193-.749,2.337C305.805,271.769,313.7,257.484,313.7,247"
                transform="translate(-214.902 -218.024)"
                fill="#a9abae"
              />
              <path
                id="Path_3"
                data-name="Path 3"
                d="M195.539,228.843a103.512,103.512,0,0,0-21.532.882c-23.052,3.067-43.679,12.188-49.374,27.609-5.823,15.765,21.954,29.477,49.374,29.477a44.755,44.755,0,0,0,24-6.95q.387-1.147.749-2.338c7.107-23.523,4.421-39.275-3.214-48.681"
                transform="translate(-120.458 -217.727)"
                fill="#002c5a"
              />
            </g>
          </g>
          <g
            id="Group_4"
            data-name="Group 4"
            transform="translate(108.385 196.791)"
          >
            <g id="Group_3" data-name="Group 3" clip-path="url(#clip-path-2)">
              <path
                id="Path_4"
                data-name="Path 4"
                d="M205.433,288.054h-1.977l-2.644,5.78-2.639-5.766v-.025a5.31,5.31,0,0,0-1.53-.225,7.6,7.6,0,0,0-3.448.689c-.6.292-1.57.76-1.57.76v6.707h1.8v-5.9a5.71,5.71,0,0,1,2.809-.7,3.715,3.715,0,0,1,.632.094c1.02,2.141,2.852,5.985,2.943,6.191.128.284.025-.076-.26.558a1.848,1.848,0,0,1-1.749.868v1.581c.106.006.208.013.321.013a3.326,3.326,0,0,0,3.255-2.079ZM144,287.118a5.092,5.092,0,0,0-2.659.7v3.763h2.45c1.4,0,2.9-.49,2.9-2.23s-1.853-2.229-2.689-2.229m4.519,2.288h0a3.538,3.538,0,0,1-2.672,3.494.736.736,0,0,1,.49.3c.1.121.077.087,2.129,2.858H146.09l-2.1-2.914h-2.648v2.914h-1.8V287s.974-.468,1.57-.759a6.829,6.829,0,0,1,3.3-.689,3.988,3.988,0,0,1,4.109,3.733h0c0,.02,0,.04,0,.06s0,.04,0,.06m42.109-1.352v6.736a11.677,11.677,0,0,1-1.27.759,6.728,6.728,0,0,1-3.3.689c-2.21-.134-3.362-1.593-3.362-4.277v-3.908h1.831v3.967c0,1.739.545,2.539,1.939,2.654a3.637,3.637,0,0,0,2.359-.7v-5.925Zm-15.965,5.925a5.1,5.1,0,0,0,2.659.7,2.558,2.558,0,0,0,2.689-2.654,2.6,2.6,0,0,0-2.748-2.669,3.783,3.783,0,0,0-2.6,1.091Zm-1.8-8.241h1.8v3.141a4.46,4.46,0,0,1,2.994-1.091,3.968,3.968,0,0,1,4.185,4.173,4.04,4.04,0,0,1-4.112,4.277,6.827,6.827,0,0,1-3.3-.689c-.6-.292-1.571-.759-1.571-.759Zm-8.881,10.235h1.8v-5.457a2.773,2.773,0,0,1,2.47-1.165c1.206,0,1.67.663,1.67,2.226v4.4h1.8V290.9c0-2.419-1.425-3.111-3.052-3.111a3.585,3.585,0,0,0-2.891,1.253v-3.3h-1.8Zm-5.308-6.091h0v4.056c0,1.74.945,2.3,2.659,2.3a13.392,13.392,0,0,0,1.948-.177v-1.608a7.042,7.042,0,0,1-1.541.221c-1.046,0-1.263-.605-1.263-1.165v-3.628h2.2v-1.562h-2.2v-2.581h-1.8v4.144Zm-2.749,2.095a2.545,2.545,0,1,0-5.087,0,2.548,2.548,0,1,0,5.087,0m-6.917.03a4.377,4.377,0,0,1,8.748,0c0,3.156-2.238,4.233-4.375,4.233s-4.373-1.077-4.373-4.233"
                transform="translate(-126.205 -246.997)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </svg>
    </a>
    {#if currentPage === "midSlides" && currentSlide !== slidesObj?.data?.entry?.midSlides?.length - 1}
      <a
        href={slidesObj.data.entry.ctaButton}
        in:fade={{ delay: 500 }}
        out:fade={{ duration: 400 }}
        class="btn t-sm-18"
        style={`color:${
          JSON.parse(
            slidesObj?.data?.entry?.midSlides[currentSlide]?.buttonColor
              ?.color?.[0] ?? "{}"
          )?.color
        };border-color:${
          JSON.parse(
            slidesObj?.data?.entry?.midSlides[currentSlide]?.buttonColor
              ?.color?.[0] ?? "{}"
          )?.color
        }`}
      >
        GET IN TOUCH
      </a>
    {/if}
  </div>
  <div class="slider-background">
    <div class="slider-gradient-background" />
  </div>
  {#if currentPage === "startSlide"}
    <div in:fade={{ delay: 500 }} out:fade={{ duration: 400 }}>
      <StartSlide
        bind:currentPage
        data={slidesObj?.data?.entry?.startSlide[0]}
      />
    </div>
  {/if}

  {#if currentPage === "midSlides"}
    <div in:fade={{ delay: 500 }} out:fade={{ duration: 400, delay: 500 }}>
      <MidSlides
        bind:currentSlide
        bind:currentPage
        bind:carousel
        data={slidesObj?.data?.entry?.midSlides}
        lastSlideData={slidesObj?.data?.entry?.lastSlide[0]}
      />
    </div>
  {/if}
</div>

<style>
  .slider-container {
    height: 100vh;
    width: 100vw;
    overflow: scroll;
  }
  .slider-container > div:not(.slider-header) {
    width: 100%;
    height: 100%;
  }
  .slider-background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .slider-gradient-background {
    background: linear-gradient(
      180deg,
      rgba(1, 45, 91, 1) 0%,
      rgba(5, 23, 43, 1) 46.3%,
      rgba(1, 45, 91, 1) 100%
    );
    width: 100%;
    height: 100%;
  }
  .slider-first-slide-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-auto-flow: row;
    justify-items: center;
    align-content: center;
  }
  .slider-first-slide-container > p {
  }
  .slider-header {
    display: flex;
    position: absolute;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    top: 33px;
    z-index: 100;
  }
  .slider-header svg {
    width: 103.136px;
    height: 92.349px;
  }
  .btn {
    border: 1px solid #032243;
    color: #032243;
    border-radius: 6px;
    cursor: pointer;
    padding: 7px 15px;
    font-weight: bold;
    transition: all 0.3s;
  }
  .btn:hover {
    opacity: 0.7;
  }
</style>
